export const environment = {
	production: true,
	publicKey:'b61daf92-4993-4050-8698-cf43b650e20b',
	
	//Desarrollo
	// clientIdPaypal: 'AZQ5rw_YLBztWOK0Jrhqdnh0LWY814vWRM5qhwKAdhotfToZWHJC1utlg4D3eSW3bjgLOkcPrzChhsuG', // sb-qvrco5830908@personal.example.com    eV^oBu6_
	// clientIdStripe: 'pk_test_JrhsQfUxOM7Re3KoBVdX0n0v00mldbO92H',
	clientIdSrPago: 'pk_dev_6104200e429ed6HrIy',

	
	//Produccion
	clientIdPaypal: 'AScNwRHeGbJOdIzZEwYK8UWkTqIGxfu6l23KlsYOaDdpwDu1ikNIqQbNAja1P4OVbzNai_7UXwxZc9td',
	// clientIdStripe: 'pk_live_eTBo2yyr73UxPX8cmuGiinOg00H2ERDt3L',
	tituloPedido:'Compra de productos para mascotas.',
	// clientIdSrPago: '',
	
	peticion:{
		// PRODUCCION
		server:'https://core.ordenaris.com/',
		// DEVELOPMENT
		// server:'http://localhost:9090/',
		// QA
		// server:'http://core-qa.ordenaris.com/',
		updateToken:'oauth/access_token',
		acceso:'api/login',
		recuperacion:'ordenaris/servicios/funcion/recuperacion',
		activarCuenta:'ordenaris/servicios/funcion/activarCuenta',
		cambiarContrasena:'ordenaris/servicios/funcion/cambiarContrasena',
		envioContacto:'ordenaris/servicios/funcion/envioContacto',

		cargarInformacionCliente:'ordenaris/api/cliente/cargarInformacionCliente',

		categorias:'ordenaris/servicios/funcion/categoriasOnline',
		ofertasOnline:'ordenaris/servicios/funcion/ofertasOnline',


		sucursales:'ordenaris/servicios/funcion/sucursalesOnline',
		horariosSucursal:'ordenaris/servicios/funcion/horariosSucursalOnline',
		seccionesOnline:'ordenaris/servicios/funcion/seccionesOnline',
		productosMarca:'ordenaris/servicios/funcion/productosMarca',
		prodcutosAlimento:'ordenaris/servicios/funcion/prodcutosAlimento',
		solicitudRecuperacion:'ordenaris/servicios/funcion/solicitudRecuperacion',
		verificarSolicitud:'ordenaris/servicios/funcion/verificarSolicitud',
		crearCuentaOnline:'ordenaris/servicios/funcion/crearCuentaOnline',


		/* request Tienda */
		rangoPreciosOnline:'ordenaris/servicios/funcion/rangoPreciosOnline',
		categoriasFiltrosTienda:'ordenaris/servicios/funcion/categoriasFiltrosTienda',
		marcasOnline:'ordenaris/servicios/funcion/marcasOnline',
		productosFiltradosOnline:'ordenaris/servicios/funcion/productosFiltradosOnline',
		sugerenciasBusqueda:'ordenaris/servicios/funcion/sugerenciasBusqueda',
		actualizarCantidadesFiltros: 'ordenaris/servicios/funcion/actualizarCantidadesFiltros',
		informacionMarca: 'ordenaris/servicios/funcion/informacionMarca',


		/* request Informacion Producto */
		detalleProductoOnline:'ordenaris/servicios/funcion/detalleProductoOnline',
		fotografiasInventario:'ordenaris/servicios/funcion/fotografiasInventario',
		previewInventarioDetalle:'ordenaris/servicios/funcion/previewInventarioDetalle',
		productosRelacionados:'ordenaris/servicios/funcion/productosRelacionados',
		reseniasProducto:'ordenaris/servicios/funcion/reseniasProducto',
		permisosProducto:'ordenaris/servicios/funcion/permisosProducto',
		preguntasProducto:'ordenaris/servicios/funcion/preguntasProducto',
		wishlistProducto:'ordenaris/servicios/funcion/wishlistProducto',
		nuevaVisita:'ordenaris/servicios/funcion/nuevaVisita',
		validarDisponibilidadProducto: 'ordenaris/servicios/funcion/validarDisponibilidadProducto',

		/* request Carrito Compra */
		totalProductosCarrito:'ordenaris/servicios/funcion/totalProductosCarrito',
		registrarProducto:'ordenaris/servicios/funcion/registrarProducto',
		cargarCarrito:'ordenaris/servicios/funcion/cargarCarrito',
		productosComprados:'ordenaris/servicios/funcion/productosComprados',
		updateProductoVenta:'ordenaris/servicios/funcion/updateProductoVenta',
		aplicarCupon:'ordenaris/servicios/funcion/aplicarCupon',
		vincularVentaCliente:'ordenaris/servicios/funcion/vincularVentaCliente',
		terminarVenta:'ordenaris/api/cliente/terminarVenta',
		registrarDireccionVenta:'ordenaris/servicios/funcion/registrarDireccionVenta',
		eliminarProductoCarrito:'ordenaris/servicios/funcion/eliminarProductoCarrito',
		limpiarCarrito: 'ordenaris/servicios/funcion/limpiarCarrito',

		/* request buscar Productos */
		buscarProductos:'ordenaris/servicios/funcion/buscarProductos',

		/* request Pedidos Cliente */
		ventasCliente:'ordenaris/api/cliente/ventasCliente',
		detalleVenta:'ordenaris/api/cliente/detalleVenta',

		/* request API Asentamiento */
		buscarColonias:'ordenaris/servicios/funcion/buscarColonias',
		consultarDireccion:'ordenaris/servicios/funcion/consultarDireccion',
		cargarDirecciones:'ordenaris/api/cliente/cargarDirecciones',

		/* request API Asentamiento */
		listarServiciosPaqueteria:'ordenaris/servicios/funcion/listarServiciosPaqueteria',

		/* request API Paqueteria */
		cotizarEnvio:'ordenaris/servicios/funcion/cotizarEnvio',


		/* request Newsletter */
		suscribir:'ordenaris/servicios/funcion/suscribir',
		desuscribir:'ordenaris/servicios/funcion/desuscribir',



		/* request mi cuenta datos personales */
		cargarDatosPersonales:'ordenaris/api/cliente/cargarDatosPersonales',
		actualizarDatosPersonales:'ordenaris/api/cliente/actualizarDatosPersonales',
		actualizarClave:'ordenaris/api/cliente/actualizarClave',
		cargarDireccionesEnvio:'ordenaris/api/cliente/cargarDireccionesEnvio',
		actualizarDireccionEnvio:'ordenaris/api/cliente/actualizarDireccionEnvio',
		eliminarDireccionEnvio:'ordenaris/api/cliente/eliminarDireccionEnvio',
		listaWishList:'ordenaris/api/cliente/cargarWishList',
		paginarPedidos:'ordenaris/api/cliente/paginarPedidos',
		informacionPedido:'ordenaris/api/cliente/informacionPedido',
		cancelarCompraTerminada:'ordenaris/api/cliente/cancelarCompraTerminada',
		navegacion:'ordenaris/servicios/funcion/navegacion',



		pruebaPago:'ordenaris/servicios/funcion/pruebaPago'
	},
	validacion:{
		correo: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
		telefono: /^\d{7,10}?$/,
		codigoPostal: /^\d{5}?$/,
		celular: /^\d{10}?$/,
		numero: /^\d+$/,
		folio: /(^P|^V)-([A-Z]{2})(\d{7})?$/,
		rfc: /^[a-zA-ZÃƒâ€˜&]{3,4}[0-9]{2}[0-1][0-9][0-3][0-9]([a-zA-Z0-9]{3})$/,
		
		visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
    	masterCard: /^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/,
    	americanExpress: /^3[47][0-9]{13}$/,
    	cvc: /^[0-9]{3,4}$/,
    	anio: /^[0-9]{4}$/,
    	mes: /^[0-9]{2}$/
	},
	alerta:{
		pago: {
			validacion: {
				load: {
					mensaje: "Lo sentimos, no ha cargado correctamente la herramienta de pagos.",
					titulo: "Pawerful - Forma de pago",
					estilo: "alerta-warning",
					icono: 'fas fa-exclamation-circle'
				},
				nombre: {
					mensaje: "Por favor, ingrese el nombre del titular de la tarjeta.",
					titulo: "Pawerful - Forma de pago",
					estilo: "alerta-warning",
					icono: 'fas fa-exclamation-circle'
				},
				paterno: {
					mensaje: "Por favor, ingrese el apellido paterno del titular de la tarjeta.",
					titulo: "Pawerful - Forma de pago",
					estilo: "alerta-warning",
					icono: 'fas fa-exclamation-circle'
				},
				tarjeta: {
					mensaje: "Lo sentimos, el número de tarjeta es inválido, o se encuentra vacío.",
					titulo: "Pawerful - Forma de pago",
					estilo: "alerta-warning",
					icono: 'fas fa-exclamation-circle'
				},
				cvc: {
					mensaje: "Lo sentimos, la clave de seguridad es inválida, o se encuentra vacía.",
					titulo: "Pawerful - Forma de pago",
					estilo: "alerta-warning",
					icono: 'fas fa-exclamation-circle'
				},
				expiracion: {
					mensaje: "Lo sentimos, la fecha de expiración es inválida, o se encuentra vacía.",
					titulo: "Pawerful - Forma de pago",
					estilo: "alerta-warning",
					icono: 'fas fa-exclamation-circle'
				},
				direccion:{
					mensaje: "Lo sentimos, no ha ingresado la dirección de la tarjeta.",
					titulo: "Pawerful - Forma de pago",
					estilo: "alerta-warning",
					icono: 'fas fa-exclamation-triangle'
				},
				codigoPostal:{
					vacio:{
						mensaje: "Lo sentimos, no has ingresado el código postal de la dirección de tu tarjeta.",
						titulo: "Pawerful - Forma de pago",
						estilo: "alerta-warning",
						icono: 'fas fa-exclamation-triangle'
					},
					formato:{
						mensaje: "Lo sentimos, el código postal ingresado no tiene el formato correcto.",
						titulo: "Pawerful - Forma de pago",
						estilo: "alerta-warning",
						icono: 'fas fa-exclamation-triangle'
					},
					notFound:{
						mensaje: "Lo sentimos, no se han encontrado colonias con el código postal ingresado.",
						titulo: "Pawerful - Forma de pago",
						estilo: "alerta-warning",
						icono: 'fas fa-exclamation-triangle'
					}
				},
				colonia:{
					mensaje: "Lo sentimos, seleccionado la colonia de la dirección de tu tarjeta.",
					titulo: "Pawerful - Forma de pago",
					estilo: "alerta-warning",
					icono: 'fas fa-exclamation-triangle'
				}
			}
		},
		/*pago: {
			validacion: {
				load: {
					mensaje: "Lo sentimos, no ha cargado correctamente la herramienta de pagos.",
					titulo: "Pawerful Pet Shop - Forma de pago",
					estilo: "alerta-warning",
					icono: 'fas fa-exclamation-circle'
				},
				nombre: {
					mensaje: "Por favor, ingrese el nombre del titular de la tarjeta.",
					titulo: "Pawerful Pet Shop - Forma de pago",
					estilo: "alerta-warning",
					icono: 'fas fa-exclamation-circle'
				},
				tarjeta: {
					mensaje: "Lo sentimos, el número de tarjeta es inválido, o se encuentra vacío.",
					titulo: "Pawerful Pet Shop - Forma de pago",
					estilo: "alerta-warning",
					icono: 'fas fa-exclamation-circle'
				},
				cvc: {
					mensaje: "Lo sentimos, la clave de seguridad es inválida, o se encuentra vacía.",
					titulo: "Pawerful Pet Shop - Forma de pago",
					estilo: "alerta-warning",
					icono: 'fas fa-exclamation-circle'
				},
				expiracion: {
					mensaje: "Lo sentimos, la fecha de expiración es inválida, o se encuentra vacía.",
					titulo: "Pawerful Pet Shop - Forma de pago",
					estilo: "alerta-warning",
					icono: 'fas fa-exclamation-circle'
				}
			}Tu contraseña no cumple con el formato requerido. Debe tener al menos 8 caracteres, 1 letra mayúscula, 1 minúscula, 1 número y 1 carácter especiales.
		},*/
		cupones:{
			success:{
				mensaje: "El cupón de descuento se ha aplicado correctamente.",
				titulo: "Pawerful Pet Shop - Cupon de descuento",
				estilo: "alerta-success",
				icono: 'fas fa-check-circle'
			},
		},
		cancelacion:{
			empty:{
				mensaje: "No has seleccionado un motivo de tu cancelación.",
				titulo: "Pawerful Pet Shop - Cancelación",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
			},
			success:{
				mensaje: "La cancelación de tu pedido se ha realizado correctamente.",
				titulo: "Pawerful Pet Shop - Cancelación",
				estilo: "alerta-success",
				icono: 'fas fa-check-circle'
			},
			fail:{
				mensaje: "Lo sentimos, no se ha podido cancelar tu pedido, favor de ponerte en contacto con nosotros.",
				titulo: "Pawerful Pet Shop - Cancelación",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
			}
		},
		newsletter:{
			success:{
				mensaje: "Ahora estas subscrito a nuestro newsletter.",
				titulo: "Pawerful Pet Shop - Newsletter",
				estilo: "alerta-success",
				icono: 'fas fa-check-circle'
			},
			fail:{
				mensaje: "Lo sentimos, no se ha podido registrar tu correo en nuestro newsletter.",
				titulo: "Pawerful Pet Shop - Newsletter",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
			}
		},
		cambio:{
			password:{
				mensaje: "Lo sentimos, no has ingresado tu nueva contraseña.",
				titulo: "Pawerful Pet Shop - Cambio de contraseña",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
			},
			confirmar:{
				mensaje: "Lo sentimos, no has confirmado tu nueva contraseña.",
				titulo: "Pawerful Pet Shop - Cambio de contraseña",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
			},
  			iguales:{
  				mensaje: "Lo sentimos, las contraseñas ingresadas no coinciden.",
				titulo: "Pawerful Pet Shop - Cambio de contraseña",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
  			},
  			success:{
  				mensaje: "La contraseña de tu cuenta se ha actualizado correctamente..",
				titulo: "Pawerful Pet Shop - Cambio de contraseña",
				estilo: "alerta-success",
				icono: 'fas fa-check-circle'
  			},
  			expired:{
  				mensaje: "Lo sentimos, el link ha expirado, favor volver a solicitar el cambio de contraseña.",
				titulo: "Pawerful Pet Shop - Cambio de contraseña",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
  			},
			validarContraseña: {
				mensaje: "<span>Tu contraseña no cumple con el formato requerido. Debe tener al menos 8 caracteres, 1 letra mayúscula, 1 minúscula, 1 número y 1 carácter especiales.</span>",
				titulo: "Pawerful Pet Shop - Registro de cuenta",
				estilo: "alerta-warning",
				icono: 'fas fa-check-circle'
			}
		},
		carrito:{
			vacio:{
				mensaje: "Lo sentimos, tu carrito de compras se encuentra vacío.",
				titulo: "Pawerful Pet Shop - Carrito de compras",
				estilo: "alerta-info",
				icono: 'fas fa-exclamation-circle'
			}
		},
		direccion:{
			empty:{
				mensaje: "Lo sentimos, no has seleccionado o ingresado el domicilio de envío.",
				titulo: "Pawerful Pet Shop - Dirección de envío",
				estilo: "alerta-danger",
				icono: 'fas fa-exclamation-triangle'
			},
			referencia:{
				mensaje: "Lo sentimos, no has ingresado una referencia de tu domicilio de envío.",
				titulo: "Pawerful Pet Shop - Dirección de envío",
				estilo: "alerta-danger",
				icono: 'fas fa-exclamation-triangle'
			},
			calle:{
				mensaje: "Lo sentimos, no has ingresado la calle de tu dirección de envío.",
				titulo: "Pawerful Pet Shop - Dirección de envío",
				estilo: "alerta-danger",
				icono: 'fas fa-exclamation-triangle'
			},
			codigoPostal:{
				vacio:{
					mensaje: "Lo sentimos, no has ingresado el código postal de tu dirección de envío.",
					titulo: "Pawerful Pet Shop - Dirección de envío",
					estilo: "alerta-danger",
					icono: 'fas fa-exclamation-triangle'
				},
				formato:{
					mensaje: "Lo sentimos, el código postal ingresado no tiene el formato correcto.",
					titulo: "Pawerful Pet Shop - Dirección de envío",
					estilo: "alerta-danger",
					icono: 'fas fa-exclamation-triangle'
				},
				sinServicio: {
					mensaje: "Lo sentimos, tenemos problemas al cotizar su envío, por favor inténtenlo nuevamente o póngase en contacto con atención a clientes.",
					titulo: "Pawerful Pet Shop - Dirección de envío",
					estilo: "alerta-danger",
					icono: 'fas fa-exclamation-triangle'
				}
			},
			colonia:{
				mensaje: "Lo sentimos, no has seleccionado la colonia de tu dirección de envío.",
				titulo: "Pawerful Pet Shop - Dirección de envío",
				estilo: "alerta-danger",
				icono: 'fas fa-exclamation-triangle'
			}
		},
		paginacion:{
			vacio:{
				mensaje: "Lo sentimos, no has ingresado el número de página al cual ir.",
				titulo: "Pawerful Pet Shop",
				estilo: "alerta-danger",
				icono: 'fas fa-exclamation-triangle'
			},
			formato:{
				mensaje: "Lo sentimos, el valor de página no tiene el formato correcto.",
				titulo: "Pawerful Pet Shop",
				estilo: "alerta-danger",
				icono: 'fas fa-exclamation-triangle'
			},
			limite:{
				mensaje: "Lo sentimos, el valor de página no existe.",
				titulo: "Pawerful Pet Shop",
				estilo: "alerta-danger",
				icono: 'fas fa-exclamation-triangle'
			}
		},
		request:{
			notFound:{
				mensaje: "Lo sentimos, el servicio solicitado no está disponible o no existe.",
				titulo: "Pawerful Pet Shop - Seguridad",
				estilo: "alerta-danger",
				icono: 'fas fa-exclamation-triangle'
			},
			failExpired: {
				mensaje: "Lo sentimos, tu cuenta ha expirado, favor de acceder nuevamente.",
				titulo: "Pawerful Pet Shop - Seguridad",
				estilo: "alerta-danger",
				icono: 'fas fa-exclamation-triangle'
			},
			failDisabled: {
				mensaje: "Lo sentimos, tu cuenta se encuentra deshabilitada, favor de activar su cuenta desde el correo de bienvenida.",
				titulo: "Pawerful Pet Shop - Seguridad",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
			},
			failLocked: {
				mensaje: "Lo sentimos, tu cuenta se encuentra bloqueada, favor de contactarnos y ver el motivo de su bloqueo.",
				titulo: "Pawerful Pet Shop - Seguridad",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
			},
			failBadCredentials: {
				mensaje: "Lo sentimos, tus datos de acceso son incorrectos, favor de verificarlos e intentarlos nuevamente.",
				titulo: "Pawerful Pet Shop - Seguridad",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
			},
			failBadRequest: {
				mensaje: "Lo sentimos, se ha tenido un error en la solicitud del servicio.",
				titulo: "Pawerful Pet Shop - Seguridad",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
			},
			failNotFound: {
				mensaje: "Lo sentimos, no se encuentra el servicio solicitado.",
				titulo: "Pawerful Pet Shop - Seguridad",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
			}
		},
		seguridad: {
			desautorizado: {
				mensaje: "Lo sentimos, no tienes permisos necesarios para esta página.",
				titulo: "Pawerful Pet Shop - Seguridad",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
			}
		},
		acceso: {
			session:{
				mensaje: "Lo sentimos, debes iniciar sesión para continuar.",
				titulo: "Pawerful Pet Shop - Seguridad",
				estilo: "alerta-info",
				icono: 'fas fa-exclamation-circle'
			},
			username:{
				vacio:{
					mensaje: "Lo sentimos, no has ingresado tu correo electrónico de usuario.",
					titulo: "Pawerful Pet Shop - Seguridad",
					estilo: "alerta-warning",
					icono: 'fas fa-exclamation-circle'
				},
				formato:{
					mensaje: "Lo sentimos, tu correo electrónico no tiene el formato correcto.",
					titulo: "Pawerful Pet Shop - Seguridad",
					estilo: "alerta-warning",
					icono: 'fas fa-exclamation-circle'
				}
			},
			password: {
				mensaje: "Lo sentimos, no has ingresado tu contraseña.",
				titulo: "Pawerful Pet Shop - Seguridad",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
			}
		},
		activacion:{
			notExist:{
				mensaje: "Lo sentimos, la url que ha intentado acceder ha caducado.",
				titulo: "Pawerful Pet Shop - Activación de cuenta",
				estilo: "alerta-info",
				icono: 'fas fa-info-circle'
			},
			fail:{
				mensaje: "Lo sentimos, no se ha podido activar tu cuenta, favor de contactarnos para seguir tu caso.",
				titulo: "Pawerful Pet Shop - Activación de cuenta",
				estilo: "alerta-warning",
				icono: 'fas fa-info-circle'
			},
			success: {
				mensaje: "Tu cuenta ha sido activada, ya puedes iniciar sesión.",
				titulo: "Pawerful Pet Shop - Activación de cuenta",
				estilo: "alerta-success",
				icono: 'fas fa-check-circle'
			},
			notFound:{
				mensaje: "Lo sentimos, no hemos encontrado tu cuenta con el link proporcionado, favor de verificarlo.",
				titulo: "Pawerful Pet Shop - Activación de cuenta",
				estilo: "alerta-warning",
				icono: 'fas fa-info-circle'
			},
		},
		recuperacion: {
			correo: {
				vacio: {
					mensaje: "Lo sentimos, no has ingresado tu correo electrónico.",
					titulo: "Pawerful Pet Shop - Recuperación de contraseña",
					estilo: "alerta-warning",
					icono: 'fas fa-exclamation-circle'
				},
				formato: {
					mensaje: "Lo sentimos, el correo electrónico ingresado no tiene el formato correcto.",
					titulo: "Pawerful Pet Shop - Recuperación de contraseña",
					estilo: "alerta-warning",
					icono: 'fas fa-info-circle'
				},
				notFound:{
					mensaje: "Lo sentimos, el correo electrónico no existe en nuestra tienda.",
					titulo: "Pawerful Pet Shop - Recuperación de contraseña",
					estilo: "alerta-warning",
					icono: 'fas fa-info-circle'
				},
				success: {
					mensaje: "Hemos enviado un correo electrónico con el código de recuperación de contraseña.",
					titulo: "Pawerful Pet Shop - Recuperación de contraseña",
					estilo: "alerta-success",
					icono: 'fas fa-check-circle'
				}
			},
			telefono:{
				vacio: {
					mensaje: "Lo sentimos, no has ingresado tu número de celular.",
					titulo: "Pawerful Pet Shop - Recuperación de contraseña",
					estilo: "alerta-warning",
					icono: 'fas fa-exclamation-circle'
				},
				formato: {
					mensaje: "Lo sentimos, el número de celular ingresado no tiene el formato correcto.",
					titulo: "Pawerful Pet Shop - Recuperación de contraseña",
					estilo: "alerta-warning",
					icono: 'fas fa-info-circle'
				},
				notFound:{
					mensaje: "Lo sentimos, el número de celular no existe en nuestra tienda.",
					titulo: "Pawerful Pet Shop - Recuperación de contraseña",
					estilo: "alerta-warning",
					icono: 'fas fa-info-circle'
				},
				success: {
					mensaje: "Hemos enviado un SMS con el código de recuperación de contraseña.",
					titulo: "Pawerful Pet Shop - Recuperación de contraseña",
					estilo: "alerta-success",
					icono: 'fas fa-check-circle'
				}
			},
			fail:{
				mensaje: "Lo sentimos, se ha tenido un problemas para enviarte la solicitud favor de intentarlo más tarde.",
				titulo: "Pawerful Pet Shop - Recuperación de contraseña",
				estilo: "alerta-danger",
				icono: 'fas fa-exclamation-triangle'
			},
			solicitud:{

			}
		},
		registro:{
			nombre:{
				mensaje: "Lo sentimos, no has ingresado tu nombre (s).",
				titulo: "Pawerful Pet Shop - Registro de cuenta",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
			},
			paterno:{
				mensaje: "Lo sentimos, no has ingresado tu apellido paterno.",
				titulo: "Pawerful Pet Shop - Registro de cuenta",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
			},
			materno:{
				mensaje: "Lo sentimos, no has ingresado tu apellido materno.",
				titulo: "Pawerful Pet Shop - Registro de cuenta",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
			},
			soloLetras:{
				mensaje: "Lo sentimos, solo puede ingresar letras en el nombre y apellidos.",
				titulo: "Pawerful Pet Shop - Registro de cuenta",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
			},
			soloLetrasNombre:{
				mensaje: "Lo sentimos, solo puede ingresar letras en el nombre.",
				titulo: "Pawerful Pet Shop - Registro de cuenta",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
			},
			soloLetrasPaterno:{
				mensaje: "Lo sentimos, solo puede ingresar letras en el apellido paterno.",
				titulo: "Pawerful Pet Shop - Registro de cuenta",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
			},
			soloLetrasMaterno:{
				mensaje: "Lo sentimos, solo puede ingresar letras en el apellido materno.",
				titulo: "Pawerful Pet Shop - Registro de cuenta",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
			},
			correo:{
				vacio:{
					mensaje: "Lo sentimos, no has ingresado tu correo electrónico.",
					titulo: "Pawerful Pet Shop - Registro de cuenta",
					estilo: "alerta-warning",
					icono: 'fas fa-exclamation-circle'
				},
				formato:{
					mensaje: "Lo sentimos, tu correo electrónico no tiene el formato correcto.",
					titulo: "Pawerful Pet Shop - Registro de cuenta",
					estilo: "alerta-warning",
					icono: 'fas fa-exclamation-circle'
				}
			},
			telefono:{
				vacio:{
					mensaje: "Lo sentimos, no has ingresado tu número de celular.",
					titulo: "Pawerful Pet Shop - Registro de cuenta",
					estilo: "alerta-warning",
					icono: 'fas fa-exclamation-circle'
				},
				formato:{
					mensaje: "Lo sentimos, tu número celular no tiene el formato correcto.",
					titulo: "Pawerful Pet Shop - Registro de cuenta",
					estilo: "alerta-warning",
					icono: 'fas fa-exclamation-circle'
				}
			},
			password:{
				mensaje: "Lo sentimos, no has ingresado tu contraseña.",
				titulo: "Pawerful Pet Shop - Registro de cuenta",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
			},
			confirmar:{
				mensaje: "Lo sentimos, no has ingresado la confirmación de tu contraseña.",
				titulo: "Pawerful Pet Shop - Registro de cuenta",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
			},
			match:{
				mensaje: "Lo sentimos, tus contraseñas no coinciden.",
				titulo: "Pawerful Pet Shop - Registro de cuenta",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
			},
			find:{
				mensaje: "Lo sentimos, se ha encontrado una cuenta activa con el mismo correo electrónico o teléfono.",
				titulo: "Pawerful Pet Shop - Registro de cuenta",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
			},
			fail:{
				mensaje: "Lo sentimos, se ha tenido un problema al registrar tu cuenta.",
				titulo: "Pawerful Pet Shop - Registro de cuenta",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
			},
			success:{
				mensaje: "<span>Tu cuenta se ha registrado correctamente, te hemos enviado un correo de confirmación donde podrás activar tu cuenta.</span>",
				titulo: "Pawerful Pet Shop - Registro de cuenta",
				estilo: "alerta-success",
				icono: 'fas fa-check-circle'
			},
			contraseñaSegura: {
				mensaje: "<span>Tu contraseña no cumple con el formato requerido. Debe tener al menos 8 caracteres, 1 letra mayúscula, 1 minúscula, 1 número y 1 carácter especiales.</span>",
				titulo: "Pawerful Pet Shop - Registro de cuenta",
				estilo: "alerta-warning",
				icono: 'fas fa-check-circle'
			}
		},
		cita:{
			nombre: {
				mensaje: "Lo sentimos, no has ingresado tu nombre.",
				titulo: "Pawerful Pet Shop - Agendar cita",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
			},
			correo:{
				vacio: {
					mensaje: "Lo sentimos, no has ingresado tu correo electrónico.",
					titulo: "Pawerful Pet Shop - Agendar cita",
					estilo: "alerta-warning",
					icono: 'fas fa-exclamation-circle'
				},
				formato: {
					mensaje: "Lo sentimos, el correo electrónico ingresado no tiene el formato correcto.",
					titulo: "Pawerful Pet Shop - Agendar cita",
					estilo: "alerta-warning",
					icono: 'fas fa-info-circle'
				}
			},
			telefono:{
				vacio: {
					mensaje: "Lo sentimos, no has ingresado tu teléfono celular.",
					titulo: "Pawerful Pet Shop - Agendar cita",
					estilo: "alerta-warning",
					icono: 'fas fa-exclamation-circle'
				},
				formato: {
					mensaje: "Lo sentimos, el teléfono celular ingresado no tiene el formato correcto.",
					titulo: "Pawerful Pet Shop - Agendar cita",
					estilo: "alerta-warning",
					icono: 'fas fa-info-circle'
				}
			},
			sucursal: {
				mensaje: "Lo sentimos, no has sleccionado una sucursal.",
				titulo: "Pawerful Pet Shop - Agendar cita",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
			},
			fecha: {
				mensaje: "Lo sentimos, no has sleccionado una fecha de cita.",
				titulo: "Pawerful Pet Shop - Agendar cita",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
			},
			hora: {
				mensaje: "Lo sentimos, no has sleccionado un horario para la cita.",
				titulo: "Pawerful Pet Shop - Agendar cita",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
			},
		},
		producto:{
			cantidad:{
				mensaje: "Lo sentimos, no tenemos suficiente stock, te notificaremos cuando tengamos mas de este producto.",
				titulo: "Pawerful Pet Shop - Agendar cita",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
			}
		},
		venta:{
			pago:{
				success:{
					mensaje: "Tu pago se ha registrado correctamente.",
					titulo: "Pawerful Pet Shop - Compras",
					estilo: "alerta-success",
					icono: 'fas fa-check'
				},
				fail:{
					mensaje: "Lo sentimos, se ha tenido un problema al registrar tu pago, favor de contactarnos.",
					titulo: "Pawerful Pet Shop - Compras",
					estilo: "alerta-warning",
					icono: 'fas fa-exclamation-circle'
				}
			},
			carrito:{
				success:{
					mensaje: "El producto #nombreProducto# se ha agregado a tu carrito de compras.",
					titulo: "Pawerful Pet Shop - Carrito de compras",
					estilo: "alerta-success",
					icono: 'fas fa-check'
				},
				fail:{
					mensaje: "Lo sentimos, no se ha podido agregar el producto a tu carrito de compras.",
					titulo: "Pawerful Pet Shop - Carrito de compras",
					estilo: "alerta-warning",
					icono: 'fas fa-exclamation-circle'
				},
				nodisponible: {
					mensaje: "Lo sentimos, el producto ya no se encuentra disponible.",
					titulo: "Pawerful Pet Shop - Carrito de compras",
					estilo: "alerta-warning",
					icono: 'fas fa-exclamation-circle'
				}
			},
			success:{
				mensaje: "Tu compra se ha realizado correctamente.",
				titulo: "Pawerful Pet Shop - Compras",
				estilo: "alerta-success",
				icono: 'fas fa-check'
			},
			fail:{
				mensaje: "Lo sentimos, tu compra no se ha podido realizar correctamente.",
				titulo: "Pawerful Pet Shop - Compras",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
			}
		},
		pedidos:{
			folio:{
				vacio:{
					mensaje: "Lo sentimos, no has ingresado el folio de tu compra.",
					titulo: "Pawerful Pet Shop - Perdidos",
					estilo: "alerta-info",
					icono: 'fas fa-exclamation-circle'
				},
				formato:{
					mensaje: "Lo sentimos, el folio ingresado es incorrecto.",
					titulo: "Pawerful Pet Shop - Perdidos",
					estilo: "alerta-info",
					icono: 'fas fa-exclamation-circle'
				}
			}
		},
		cuenta:{
			datos:{
				mensaje: "Lo sentimos, se han encontrado errores al intentar actualizar tus datos personales.<br>#detalle#",
				titulo: "Pawerful Pet Shop - Datos personales",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
			},
			direccion:{
				mensaje: "Lo sentimos, se han encontrado errores al intentar actualizar los datos de la dirección de envío.<br>#detalle#",
				titulo: "Pawerful Pet Shop - Dirección de envío",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
			}
		},
		contacto:{
			fail:{
				mensaje: "Lo sentimos, se ha tenido un problema al envíar tus datos de contacto",
				titulo: "Pawerful Pet Shop - Contacto",
				estilo: "alerta-danger",
				icono: 'fas fa-exclamation-triangle'
			},
			success:{
				mensaje: "Hemos recibido tus datos de contacto, nos comunicaremos a la brevedad contigo",
				titulo: "Pawerful Pet Shop - Contacto",
				estilo: "alerta-success",
				icono: 'fas fa-check-circle'
			},
			nombre:{
				mensaje: "Lo sentimos, has ingresado tu nombre",
				titulo: "Pawerful Pet Shop - Contacto",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
			},
			telefono:{
				vacio:{
					mensaje: "Lo sentimos, has ingresado tu número de teléfono",
					titulo: "Pawerful Pet Shop - Contacto",
					estilo: "alerta-warning",
					icono: 'fas fa-exclamation-circle'
				}
			},
			correo:{
				vacio:{
					mensaje: "Lo sentimos, has ingresado tu correo electrónico",
					titulo: "Pawerful Pet Shop - Contacto",
					estilo: "alerta-warning",
					icono: 'fas fa-exclamation-circle'
				},
				formato:{
					mensaje: "Lo sentimos, el correo electrónico no tiene el formato correcto",
					titulo: "Pawerful Pet Shop - Contacto",
					estilo: "alerta-warning",
					icono: 'fas fa-exclamation-circle'
				}
			},
			descripcion:{
				mensaje: "Lo sentimos, no has ingresado mas detalles de tu contacto",
				titulo: "Pawerful Pet Shop - Contacto",
				estilo: "alerta-warning",
				icono: 'fas fa-exclamation-circle'
			}
		}
	}
};
